import { Asterisk } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/site";

const Marquee = () => (
  <div
    className="marquee overflow-hidden border-y border-slate-200 bg-white py-5"
    data-testid="tech-marquee"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div
          key={copy}
          aria-hidden={copy === 1}
          className="flex items-center"
        >
          {MARQUEE_ITEMS.map((item) => (
            <span
              key={`${copy}-${item}`}
              className="flex items-center gap-8 pr-8 font-display text-[13px] font-medium uppercase tracking-[0.3em] text-soot"
            >
              {item}
              <Asterisk className="h-4 w-4 text-primary" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
